/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import BasicUnit from 'astro/server/unit/basic';

import * as Influence from 'astro/util/influence';


export default class extends BasicUnit
{
  installPassiveBenefit ()
  {
    const influence = Influence.makeAttack(this.getCass().getUser(), this.getLocation(), 2);

    this.getZone().getAttributes().installInfluence(influence);
  }


}
